import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <Button asChild variant="ghost" className="mb-4"><Link to="/"><ChevronLeft className="h-4 w-4 mr-1" />Volver</Link></Button>
        <h1 className="text-3xl font-heading mb-6">Politica de Privacidad</h1>
        <div className="prose prose-sm max-w-none space-y-4 text-muted-foreground">
          <h2 className="text-lg font-medium text-foreground">1. Responsable del tratamiento</h2>
          <p>El responsable del tratamiento de los datos personales es el titular de este negocio de peluqueria. Puede contactar con nosotros a traves de los datos de contacto indicados en nuestra pagina web.</p>

          <h2 className="text-lg font-medium text-foreground">2. Datos que recogemos</h2>
          <p>Recogemos los siguientes datos personales cuando el usuario realiza una reserva:</p>
          <ul className="list-disc pl-6">
            <li>Nombre completo</li>
            <li>Numero de telefono</li>
          </ul>

          <h2 className="text-lg font-medium text-foreground">3. Finalidad del tratamiento</h2>
          <p>Los datos personales proporcionados seran tratados con las siguientes finalidades:</p>
          <ul className="list-disc pl-6">
            <li>Gestion de citas y reservas</li>
            <li>Comunicacion relacionada con las citas reservadas</li>
            <li>Identificacion del cliente en el establecimiento</li>
          </ul>

          <h2 className="text-lg font-medium text-foreground">4. Base legal del tratamiento</h2>
          <p>La base legal para el tratamiento de los datos es el consentimiento del interesado al realizar la reserva, asi como la ejecucion del contrato de prestacion de servicios. Reglamento (UE) 2016/679 (RGPD).</p>

          <h2 className="text-lg font-medium text-foreground">5. Conservacion de datos</h2>
          <p>Los datos personales se conservaran mientras exista una relacion comercial y durante el tiempo necesario para cumplir con las obligaciones legales aplicables.</p>

          <h2 className="text-lg font-medium text-foreground">6. Derechos del usuario</h2>
          <p>El usuario puede ejercer los siguientes derechos: acceso, rectificacion, supresion, limitacion del tratamiento, portabilidad y oposicion. Para ello, puede contactar con nosotros a traves de los medios indicados en la web.</p>

          <h2 className="text-lg font-medium text-foreground">7. Seguridad</h2>
          <p>Hemos adoptado las medidas tecnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteracion, perdida, tratamiento o acceso no autorizado.</p>
        </div>
      </div>
    </div>
  );
}
